export enum ApiStatus {
  OK,
  Error,
  OutOfTime,
  AccessDenied,
  UserNotPresent,
}
